import { createSlice } from '@reduxjs/toolkit';

let hideTimeoutId = null;

const toastSlice = createSlice({
  name: 'alert',
  initialState: {
    show: false,
    type: 'success',
    message: ''
  },
  reducers: {
    showToast: (state, action) => {
      const { type, message } = action.payload;
      state.show = true;
      state.type = type;
      state.message = message;
    },
    hideToast: (state) => {
      state.show = false;
      state.type = '';
      state.message = '';
    }
  }
});

const { showToast: rawShowToast, hideToast } = toastSlice.actions;

const showToast = (type, message, timeout = 3000) => (dispatch) => {
  if (hideTimeoutId) {
    clearTimeout(hideTimeoutId);
    hideTimeoutId = null;
  }

  dispatch(rawShowToast({ type, message }));

  hideTimeoutId = setTimeout(() => {
    dispatch(hideToast());
    hideTimeoutId = null;
  }, timeout);
};

export { showToast, hideToast };
export default toastSlice.reducer;